// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"buttonStyles_buttonWrapper__2-CRJ","button":"buttonStyles_button__9scz9","active":"buttonStyles_active__2gkG2"};